import React from "react";
import PropTypes from "prop-types";
import "./TextBlock.scss";

const TextBlock = ({
	hat,
	title,
	subtitle,
	paragraph,
	disclaimer,
	type,
	color,
	align,
	fontSize,
	fontWeight,
	lineHeight,
}) => {
	const typeClass = {
		h1: "h1-block",
		sectionHeader: "section-header",
		spec: "spec",
		p: "p-block",
		disclaimer: "disclaimer",
	};

	const fontColors = {
		white: "white",
		black: "black",
	};

	const alignClass = {
		left: "left",
		center: "center",
	};

	const style = typeClass[type] || "";

	return (
		<div
			className={`text-container ${style} ${fontColors[color]} ${alignClass[align]}`}>
			<div className="title-container">
				{hat && <p className="hat">{hat}</p>}
				{title && <p className="title">{title}</p>}
			</div>
			{subtitle && <p className="subtitle">{subtitle}</p>}
			{paragraph && (
				<p
					className={`paragraph ${
						fontSize ? `font-size-${fontSize}` : ""
					}`}
					style={{
						...(fontSize ? { fontSize: `${fontSize}px` } : {}),
						...(fontWeight ? { fontWeight: fontWeight } : {}),
						...(lineHeight ? { lineHeight: `${lineHeight}%` } : {}),
					}}>
					{paragraph}
				</p>
			)}
			{disclaimer && <p className="disclaimer">{disclaimer}</p>}
		</div>
	);
};

TextBlock.propTypes = {
	hat: PropTypes.string,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	paragraph: PropTypes.string.isRequired,
	disclaimer: PropTypes.string.isRequired,
	type: PropTypes.oneOf(["h1", "sectionHeader", "spec", "p"]),
	color: PropTypes.oneOf(["white", "black"]),
	align: PropTypes.oneOf(["left", "center"]),
	fontSize: PropTypes.number,
	fontWeight: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.oneOf(["normal", "bold", "lighter", "bolder"]),
	]),
};

export default TextBlock;
